import { fromSymbol } from '@/common/domain/token/Currency';
import { Fiat } from '@/common/domain/token/Fiat';

export interface BackendFiat {
  value: number;
  currency: string;
}

export const toFiat = (backendFiat: BackendFiat): Fiat => new Fiat(backendFiat.value, fromSymbol(backendFiat.currency));
